import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { temperaturaFrio, temperaturaMorno, temperaturaQuente } from '../temperatura';

@Component({
    selector: 'sgt-temperatura-multiselect',
    templateUrl: './temperatura-multiselect.component.html',
    styleUrls: ['./temperatura-multiselect.component.less']
})
export class TemperaturaMultiselectComponent implements OnInit {
    /** temperaturas selecionadas */
    @Input() temperaturas: number[];
    /** Ao alterar a seleção das temperaturas */
    @Output() temperaturasChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Temperatura';
    @Input() checked = 'Temperatura'
    @Input() checkedPlural = 'Temperaturas';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todoas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma temperatura encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowQuente = true;
    @Input() isShowMorno = true;
    @Input() isShowFrio = true;

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-temperatura ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as temperaturas para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        // Quente
        if (this.isShowQuente) {
            selects.push({
                id: temperaturaQuente.id,
                name: temperaturaQuente.nome,
                classes: 'multiselect-item-temperatura multiselect-item-temperatura-quente'
            });
        }
        // Morno
        if (this.isShowMorno) {
            selects.push({
                id: temperaturaMorno.id,
                name: temperaturaMorno.nome,
                classes: 'multiselect-item-temperatura multiselect-item-temperatura-morno'
            });
        }
        // Frio
        if (this.isShowFrio) {
            selects.push({
                id: temperaturaFrio.id,
                name: temperaturaFrio.nome,
                classes: 'multiselect-item-temperatura multiselect-item-temperatura-frio'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção das temperaturas */
    onChange() {
        this.temperaturasChange.emit(this.temperaturas);
    }
}
